import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefRankingHouseHome } from './interface/IRefRankingHouseHome';

@Entity('ref_ranking_house_home')
export class RefRankingHouseHome extends BaseEntity implements IRefRankingHouseHome{
  apiMapping = {
      id: 'id',
      name: 'name',
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;
}
